import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  UserCartCreation,
  UserGetCart,
} from '../redux/user/cart/cartServicesSync';
import { updateCartIndicator } from '../redux/user/cart/cartSlices';
import { InfinitySpin } from 'react-loader-spinner';
import LoaderScreen from './loader/loaderScreen';
import { FaBoxOpen } from 'react-icons/fa';
import { GetNewProduct } from '../redux/user/landingpageproducts/landingpage_service_syn';

// Empty state component
const EmptyProductsState = () => (
  <div className="text-center py-5">
    <div className="mb-4">
      <FaBoxOpen size={80} style={{ margin: '0 auto', color: '#c97b5a' }} />
    </div>
    <h3 className="empty-products-title mb-3">No Products Available</h3>
    <p className="empty-products-message mb-4">
      We're currently updating our inventory. Please check back later for new
      products.
    </p>
  </div>
);

const ProductSection = () => {
  const dispatch = useDispatch();
  const { newProducts, newLoading } = useSelector((state) => state.landpage);
  const { cartIndicator } = useSelector((state) => state.user_cart);

  useEffect(() => {
    dispatch(GetNewProduct({ page: 0, limit: 6 }));
  }, [dispatch]);

  const handleAddToCart = (item) => {
    dispatch(updateCartIndicator(item._id));

    dispatch(
      UserCartCreation({
        productId: item._id,
        quantity: 1,
        price: item.price,
      })
    )
      .then(() => {
        dispatch(UserGetCart());
        dispatch(updateCartIndicator(''));
      })
      .catch((error) => {
        console.log(error);
        dispatch(updateCartIndicator(''));
      });
  };

  return (
    <section className="product__section store-new-products section--padding pt-0">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-8 col-12 product__col--width__8">
            <div className="product__section--wrapper px-4">
              <div className="section__heading style2 position__relative border-bottom mb-35">
                <div><span className="store-eyebrow">FRESH FINDS FOR YOUR SPACE</span><h2 className="section__heading--maintitle">New arrivals</h2></div><a href="/shop">View all products →</a>

              </div>
              <div className="product__section--inner">
                <div className="store-product-grid store-product-grid--home">
                  {newLoading ? (
                    <div className="col-span-full flex items-center justify-center min-h-[50vh]">
                      <LoaderScreen />
                    </div>
                  ) : !newProducts?.docs || newProducts.docs.length === 0 ? (
                    <div className="col-12">
                      <EmptyProductsState />
                    </div>
                  ) : (
                    newProducts.docs.map((item) => (
                      <div key={item._id} className="store-product-cell">
                        <div className="product__items">
                          <div
                            className="product__items--thumbnail"

                          >
                            <a
                              className="product__items--link"
                              href={`/product/${item._id}`}
                            >
                              <img
                                className="product__items--img product__primary--img"
                                src={
                                  item.gallery?.[0]?.pic_url ||
                                  'assets/img/product/placeholder.webp'
                                }
                                alt={item.product_name}

                              />
                            </a>
                            {item.tags?.toLowerCase().includes('new') && (
                              <div className="product__badge">
                                <span className="product__badge--items sale">
                                  New
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="product__items--content style2 position__relative">
                            <h3 className="product__items--content__title h4">
                              <a href={`/product/${item._id}`}>
                                {item.product_name}
                              </a>
                            </h3>
                            <div className="product__items--price style2">
                              <span className="current__price style2">
                                {item.symbol}
                                {Number(item.price).toLocaleString('en-NG', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    })}
                              </span>
                              {item.discount && (
                                <span className="old__price style2">
                                  {item.symbol}
                                   {Number(item.discount).toLocaleString('en-NG', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                      })}
                                </span>
                              )}
                            </div>
                            <button
                              className="product__cart--btn__style2 primary__btn"
                              onClick={() =>
                                !cartIndicator && handleAddToCart(item)
                              }
                            >
                              {item._id === cartIndicator ? (
                                <div className="flex items-center justify-center h-full w-[70%]">
                                  <InfinitySpin width="80" color="#FFFFFF" />
                                </div>
                              ) : (
                                'Add to cart'
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-4 offset-xl-0 col-lg-6 offset-lg-3 col-md-8 product__col--width__4 ">
            <div className="deals__banner--thumbnail">
              <a
                className="deals__banner--thumbnail__link display-block position__relative"
                href="/shop"
              >
                <img
                  className="deals__banner--thumbnail__img display-block"
                  src="assets/img/banner/banner17.webp"
                  alt="deals-thumbnail-img"
                />
                <div className="deals__banner--content text-center">
                  <h2 className="deals__banner--content__maintitle h3">
                    Bring Beauty With <br />
                    Salon Equipments
                  </h2>
                  <div
                    className="deals__banner--countdown d-flex justify-content-center"

                  ></div>
                  <span className="primary__btn style2">Shop Now</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
